// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"e72c9895","280":"42996952","428":"1a1d1670","437":"fc0fc49b","442":"34707f95","447":"c22d6c2e","602":"6f57cb29","609":"f17de16a","659":"937b1977","726":"569d687d","968":"3853685e"}[chunkId] + ".chunk.js";
};